import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { uniqueId } from 'lodash';
import cn from 'classnames';
import InformationalPopover from 'chameleon/ui-stack/ui/popovers/informational-popover';
import AutocompleteSelect from 'chameleon/ui-stack/ui/forms/autocomplete-select';

// wrapper over AutocompleteSelect to work with react-hook-form
const AutocompleteSelectField = (props) => {
  const { control } = useFormContext();
  const {
    name,
    title,
    infoPopupText,
    options,
    placeholder,
    className,
    listClassName,
    rules,
    disableDropdown = false,
    onValueChange = () => {},
  } = props;

  const inputId = uniqueId(name);

  return (
    <div className="d-block mb-8" data-test-id={props['data-test-id']}>
      <div className="h-8 d-flex flex-row items-center mb-0.8">
        <label
          className="mr-4 text-base text-gray-800 font-medium"
          htmlFor={inputId}
        >
          {title}
        </label>
        {infoPopupText && (
          <InformationalPopover size="medium" defaultOpen={false}>
            <span
              aria-live="assertive"
              aria-label={infoPopupText}
              className="text-base leading-8"
            >
              {infoPopupText}
            </span>
          </InformationalPopover>
        )}
      </div>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, onBlur, value, name, ref } }) => (
          <AutocompleteSelect
            disableDropdown={disableDropdown}
            className={cn(className, 'DropdownFilter-root')}
            options={options}
            value={options.find((option) => option.value === value) || {}}
            onChange={(selectedOption) => {
              onChange(selectedOption.value);
              onValueChange(selectedOption.value);
            }}
            placeholder={{
              label: placeholder,
            }}
            listClassName={listClassName}
            inputProps={{
              onBlur,
              name,
              ref,
            }}
          />
        )}
      />
      {props.children && <div className="mt-4 px-2">{props.children}</div>}
    </div>
  );
};

export default AutocompleteSelectField;
